<template>

  <vx-card>

    <div class="vx-row">
      <div class="vx-col">
        <h5> {{ $t('vdo-live-set-topic.info-title') }}</h5>
      </div>
    </div>

    <vs-divider/>


    <!-- Avatar -->
    <div class="vx-row">

      <!-- Avatar Col -->
      <div class="vx-col">
        <div class="img-container">
          <!--TODO change picture path-->
          <img class="rounded" height="130" src="@/assets/images/portrait/small/avatar-s-11.jpg" width="130"/>
          <!--          <img class="rounded" :src="liveClassSchedule ? liveClassSchedule.teacher.picturePath:'' "/>-->
        </div>
      </div>

      <!-- Information - Col 1 -->
      <div class="vx-col flex-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.teacher-code') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.teacher.code }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.teacher') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.teacher | teacherName }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('live-class-schedule.on-air-date') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ onAirDate }}
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('vdo-set.vdo-qty') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ totalVdoQty }}
          </div>
        </div>

      </div>
      <!-- /Information - Col 1 -->

      <!-- Information - Col 2 -->
      <div class="vx-col flex-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.subject-code') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.subject.code }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.subject-name') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.subject.nameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.sections') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.sectionNo}}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('vdo-set.total-vdo-length') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            {{ totalVdoLength }}
          </div>
        </div>
      </div>

    </div>

  </vx-card>

</template>

<script>
  import {state} from "../data";
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format';
  import {secondToHHMMSSFormat} from '@/utils/data';

  export default {
    components: {},
    data() {
      return {
        local: state.local,
        vdoLiveSetEdit: state.local.vdoLiveSetEdit,

      }
    },
    computed: {
      liveClassSchedule() {
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          return this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule;
        } else {
          return null;
        }
      },
      onAirDate() {
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          let dateFrom = this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.dateTimeFrom;
          let dateTo = this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.dateTimeTo;

          return moment(dateFrom).format(dateTimeFormat.momentYYYYMMDD)
            + ' ' + this.$t('vdo-live-set.time')
            + ' ' + moment(dateFrom).format(dateTimeFormat.momenthhmm)
            + ' - ' + moment(dateTo).format(dateTimeFormat.momenthhmm);
        } else {
          return '-';
        }
      },
      totalVdoQty() {
        let totalVdoQty = 0;
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          if (this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics && this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics.length) {
            this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics.forEach(item => {
              totalVdoQty += item.vdoStreamPath ? 1 : 0;
            })
          }
        }
        return totalVdoQty;
      },
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          totalVdoLength = secondToHHMMSSFormat(this.vdoLiveSetEdit.vdoLiveSet.totalVdoLength);
        }
        return totalVdoLength;
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//

      //---------------------------------------- Event Function ------------------------------------------------------//

      //---------------------------------------- Local Function ------------------------------------------------------//
    },
  }
</script>

<style scoped>

</style>
